import styled from 'styled-components';
import { space, color, textAlign, fontSize } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';

const H1 = styled.h1<StyledSystemProps>`
  ${space};
  ${color};
  ${textAlign}
  ${fontSize}
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
`;

export default H1;

H1.defaultProps = {
  fontSize: 4,
  color: theme.colors.charcoalGrey,
};



// WEBPACK FOOTER //
// ./src/typography/H1.ts